// import React, { useState, useEffect } from 'react'
// import Pagination from '../pagination/Pagination';
// import axios from 'axios'
// import { Link } from 'react-router-dom'

// // Import Material Icons



// const NotificationMessage = () => {

//     const [notification, setNotifcation] = useState([])

//     const [show, setShow] = useState(false);
//     const handleClose = () => setShow(false);
//     const handleShow = () => setShow(true);

//     const [ad, setAd] = useState([])
//     const [showPerPage, setShowPerPage] = useState(10)
//     const [pagination, setPagination] = useState(
//         {
//             start: 0,
//             end: showPerPage
//         }
//     )

//     const onChangePagination = (start, end) => {
//         setPagination({ start: start, end: end })
//     }

// const advertisement_get = async () => {
//   const dist = sessionStorage.getItem("dist"); // ✅ Get dist

//   const res = await axios.post(`https://lionsdirectoryapi.emedha.in/notification/api/notifications/get`, {
//     dist
//   });
//   setNotifcation(res.data);
// };

// console.log(notification)

// const deleteNotify = (id) => {
//   const dist = sessionStorage.getItem("dist");

//   if (window.confirm('Are you sure to delete this data...')) {
//     axios.post(`https://lionsdirectoryapi.emedha.in/notification/api/notification/delete`, {
//       id,
//       dist
//     });
//     alert('Data deleted successfully!...');
//     advertisement_get();
//   }
// };

//     useEffect(() => {
//         advertisement_get()
//     }, [])

//     return (

//         <>
//             <div style={{ marginTop: '1rem' }} className='table-container'>
//                 <table className="styled-table table table-bordered">
//                     <thead>
//                         <tr>
//                             <th>S.No</th>
//                             <th>Message</th>
//                             <th>Title</th>
//                             <th>Date</th>
//                         </tr>

//                     </thead>
//                     <tbody className='table-bordered'>
//                         {

//                             notification.slice(pagination.start, pagination.end).map((data, index) => {
//                                 return (
//                                     <tr>
//                                         <td>{pagination.start + index + 1}</td>
//                                         <td>{data.message}</td>
//                                         <td>{data.title}</td>
//                                         <td>{data.dtime}</td>
//                                         <td className=''>
//                                             <Link to='#' className='btn btn-danger' onClick={() => deleteNotify(data.sno)}>delete</Link>
//                                         </td>
//                                     </tr>
//                                 )
//                             })
//                         }
//                     </tbody>
//                 </table>
//                 <Pagination page={showPerPage} onChangePagination={onChangePagination} total={ad.length} />
//             </div>
//         </>
//     )
// }

// export default NotificationMessage

import React, { useState, useEffect } from 'react';
import Pagination from '../pagination/Pagination';
import axios from 'axios';
import { Link } from 'react-router-dom';

const NotificationMessage = () => {
    const [notification, setNotifcation] = useState([]);

    const [showPerPage, setShowPerPage] = useState(10);

    const [pagination, setPagination] = useState({
        start: 0,
        end: showPerPage
    });

    const onChangePagination = (start, end) => {
        setPagination({
            start: start,
            end: end
        });
    };

    const advertisement_get = async () => {
        try {
            const dist = sessionStorage.getItem("dist");

            const res = await axios.post(
                `https://lionsdirectoryapi.emedha.in/notification/api/notifications/get`,
                {
                    dist
                }
            );

            setNotifcation(res.data);
        } catch (error) {
            console.error("Error fetching notifications:", error);
        }
    };

    const deleteNotify = async (id) => {
        const dist = sessionStorage.getItem("dist");

        if (window.confirm('Are you sure to delete this data...?')) {
            try {
                await axios.post(
                    `https://lionsdirectoryapi.emedha.in/notification/api/notification/delete`,
                    {
                        id,
                        dist
                    }
                );

                alert('Data deleted successfully!');
                advertisement_get();
            } catch (error) {
                console.error("Delete error:", error);
                alert("Failed to delete notification.");
            }
        }
    };

    useEffect(() => {
        advertisement_get();
    }, []);

    return (
        <>
            <div style={{ marginTop: '1rem' }} className='table-container'>
                <table className="styled-table table table-bordered">
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Message</th>
                            <th>Title</th>
                            <th>Date</th>
                            <th>Image</th>
                            <th>Action</th>
                        </tr>
                    </thead>

                    <tbody className='table-bordered'>
                        {notification
                            .slice(pagination.start, pagination.end)
                            .map((data, index) => {
                                return (
                                    <tr key={data.sno}>
                                        <td>
                                            {pagination.start + index + 1}
                                        </td>

                                        <td>
                                            {data.message}
                                        </td>

                                        <td>
                                            {data.title}
                                        </td>

                                        <td>
                                            {data.dtime}
                                        </td>

                                        <td>
                                            {data.image_url ? (
                                                <img
                                                    src={data.image_url}
                                                    alt={data.title || "Notification"}
                                                    style={{
                                                        width: "100px",
                                                        height: "70px",
                                                        objectFit: "cover",
                                                        borderRadius: "5px"
                                                    }}
                                                />
                                            ) : (
                                                <span>No Image</span>
                                            )}
                                        </td>

                                        <td>
                                            <Link
                                                to="#"
                                                className='btn btn-danger'
                                                onClick={() =>
                                                    deleteNotify(data.sno)
                                                }
                                            >
                                                Delete
                                            </Link>
                                        </td>
                                    </tr>
                                );
                            })}
                    </tbody>
                </table>

                <Pagination
                    page={showPerPage}
                    onChangePagination={onChangePagination}
                    total={notification.length}
                />
            </div>
        </>
    );
};

export default NotificationMessage;

